import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Filled } from '../../primitives/Chip/components/Filled.js';
import { Label } from '../../primitives/Chip/components/Label.js';
import { Outlined } from '../../primitives/Chip/components/Outlined.js';
import { RemoveIcon } from '../../primitives/Chip/components/RemoveIcon.js';
const isEnterKeyEvent = keyboardEvent => {
  return keyboardEvent.key === 'Enter';
};
export const Chip = /*#__PURE__*/_styled(forwardRef(({
  variant = 'filled',
  size = 'medium',
  label,
  active = false,
  disabled = false,
  icon,
  onClick,
  onClickRemove,
  ...restProps
}, ref) => {
  const Component = variant === 'filled' ? Filled : Outlined;
  const clickable = typeof onClick === 'function';
  const removeable = typeof onClickRemove === 'function';
  const withIcon = Boolean(icon);
  const handleKeyUp = event => {
    if (isEnterKeyEvent(event) && onClick) {
      // @ts-expect-error ...
      onClick(event);
    }
  };
  return _jsxs(Component, {
    ...restProps,
    ref: ref,
    variant: variant,
    size: size,
    active: active,
    disabled: disabled,
    clickable: clickable,
    removeable: removeable,
    withIcon: withIcon,
    tabIndex: clickable ? 0 : undefined,
    onClick: disabled ? undefined : onClick,
    onKeyUp: disabled ? undefined : handleKeyUp,
    children: [icon, _jsx(Label, {
      "data-label": label,
      children: label
    }), removeable && _jsx(RemoveIcon, {
      tabIndex: 0,
      "data-testid": "removeIcon",
      onClick: disabled ? undefined : onClickRemove
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "eucbruu0"
} : {
  target: "eucbruu0",
  label: "Chip"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");